import Skill from './Skill';

const favouriteClass = 'favourite';

const LessonCard = ({
    id = null,
    url = null,
    title = null,
    tutorLessonTypeText = null,
    categoriesText = null,
    skill = null,
    instructor = null,
    posterUrl = null,
    durationTime = null,
    watchCount = null,
    isFavourite = false,
    isNew = false,
}) => `
<div class="tutor-lesson-card ${isFavourite ? favouriteClass : ''}" 
        data-url="${url ? url : null}"
        data-toggle="tooltip" title="${title ? title : ''}">
    <input class="tutor-lesson-id hidden" value="${id}">
    <div class="tutor-lesson-card__favourite-marker">
        <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0.5H14V18.5L7 14L0 18.5V0.5Z" fill="white"></path>
        </svg>
    </div>
    ${isNew ? `<div class="new-tutor-lesson">New</div>` : ''}
    <div class="lesson-card__top-part">
        <div class="lesson-card__image">
            <img src="${posterUrl ? posterUrl : ''}" alt="">
            <div class="lesson-card__time-marker">
                <span>${durationTime ? durationTime : ''}</span>
            </div>
        </div>
        <div class="tutor-info">
            <div class="tutor-info-title">${tutorLessonTypeText ? tutorLessonTypeText : ''}</div>
            <div class="tutor-level">
                <div class="tutor-level-title">Level</div>
                ${Skill(skill)}
            </div>
        </div>
        <div class="lesson-card__title ellipsis-three-lines" data-url="${url ? url : ''}">
            ${title ? title : ''}
        </div>
        <div class="tutor-lesson-card-categories">${categoriesText ? categoriesText : ''}</div>
    </div>
</div>
`;

export default LessonCard;